<template>
	<div>
		<div>
			<headers :headerActive="true"></headers>
			<img src="../assets/course_index.png" class="w">
			<div class="content">
				<div class="course_list_style">
					<div class="f-20 m-t-100 m-b-50">课程列表</div>
				</div>
				<div class="b_bai selects">
					<div class="border_b select_items" v-for="(item,index) in list" :key="index">
						<span class="select_title">{{item.title}}：</span>
						<span class="select_title" 
							:class="{'select_title_active':item.active === type}"
							v-for="(type,type_index) in item.type" :key="type_index" @click="select(index,type_index)">{{type}}</span>
					</div>
				</div>
				<div class="m-t-50">
					<div class="d_flex d_flex_wrap m-b-40">
						<div class="w-285 b_bai br5 m-b-20 m-r-15 course_items" v-for="(course,course_key) in courses.slice(0,12)" :key="course_key" 
						@click="jump_course(course.courseid)">
							<img :src="course.src" class="w-285 h-160">
							<div class="f-14 color333 course_title" :title="course.title">{{course.title}}</div>
							<div class="p-l-15 d_flex f-12 d_flex_between p-r-15 course_desc">
								<div>{{course.name}}</div>
								<div>共{{course.time}}分钟/{{course.count}}小节 <span class="price_style">￥：{{course.price}}</span></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div>
			<bottoms></bottoms>
		</div>
	</div>
</template>

<script>
	import headers from './common/header.vue'
	import bottoms from './common/bottoms.vue'
	export default{
		components:{
			headers,
			bottoms
		},
		data(){
			return{
				keyWord:"全部",
				courseBelong:"",
				industry:"",
				list:[
					{
						title:"类型",
						active:'全部',
						type:['全部','免费','付费','最新','最热']
					},
					{
						title:"行业",
						active:"",
						type:['道路旅客运输','道路普货运输','道路危货运输','城市公共交通','客运场站','通用']
					},
					{
						title:"职务",
						active:"",
						type:['主要负责人','安全管理人员','卫星定位监控人员','驾驶员','押运员','通用']
					}
				],
				courses:[]
			}
		},
		mounted(){
			this.getInfo(this.keyWord,this.courseBelong,this.industry)
		},
		methods:{
			getInfo(keyWord,courseBelong,industry){
				this.$http.post('http://aqjd.aqpx.online/getChoseCourseList',{
					key_word:keyWord || "",
					coursebelong:courseBelong || "",
					industry:industry || ""
				}).then(res=>{
					console.log(res)
					this.courses = res.data.info.slice(0,12)
				})
			},
			jump_course(id){
				console.log(id)
				this.$router.push({
					path:"/courseDetail",
					query:{
						id
					}
				})
			},
			select(index,index2){
				this.list[index].active = this.list[index].type[index2]
				console.log(this.list[index].type[index2])
				this.getInfo(this.list[0].active,this.list[1].active,this.list[2].active)
			}
		}
	}
</script>

<style scoped>
	.selects{
		border:1px solid #e5e5e5;
	}
	.border_b{
		border-bottom: 1px solid #e5e5e5;
	}
	.select_items{
		display: flex;
		align-items: center;
		height:60px;
	}
	.select_title{
		font-size: 14px;
		color:#666;
		text-align: center;
		margin-left:45px;
	}
	.color333{color:#333;}
	.course_title{
		padding:0 15px;
		line-height: 50px;
		font-weight: bold;
		width:280px;
		overflow: hidden;
		white-space: nowrap;
	    text-overflow: ellipsis;
	}
	.select_title_active{
		color:#247ce9;
		font-weight: bold;
	}
	.course_desc{
		padding-bottom: 20px;
	}
	.price_style{
		color:red;
		margin-left:5px;
	}
	.course_items{
		cursor:pointer; 
	}
</style>
